/**
 * Trigger a client-side file download from a Blob.
 *
 * Creates a temporary object URL, clicks a hidden anchor, then revokes
 * the URL. Used by MergeDownloadButton, collection download, and any
 * future blob-download flows.
 */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  const a = document.createElement("a")
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}
